import matter from 'gray-matter';

// Light markdown helpers — full content pipeline (front-matter parsing,
// reading-time, TOC extraction) is wired up in Phase B alongside react-markdown.

const WORDS_PER_MINUTE = 220;

export function parseFrontMatter(raw) {
  const { data, content } = matter(raw);
  return { data, content };
}

export function estimateReadingTime(content) {
  if (!content) return 1;
  const words = content.trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / WORDS_PER_MINUTE));
}

export function extractHeadings(content) {
  if (!content) return [];
  const lines = content.split('\n');
  const headings = [];
  for (const line of lines) {
    const match = /^(#{1,3})\s+(.+?)\s*$/.exec(line);
    if (!match) continue;
    // The page <h1> is the frontmatter title (ArticleHero). A stray body `# `
    // is rendered as an h2 (see Article.jsx markdownComponents), so treat it as
    // level 2 here too — keeps the TOC consistent with the rendered DOM.
    const level = Math.max(2, match[1].length);
    const text = match[2].replace(/[*_`]/g, '').trim();
    const slug = text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-');
    headings.push({ level, text, slug });
  }
  return headings;
}
